import { render } from "./AdminStringList.vue?vue&type=template&id=dbc3d776"
import script from "./AdminStringList.vue?vue&type=script&lang=js"
export * from "./AdminStringList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gelo\\Desktop\\Firebase Project\\eporrtfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__